/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Timetobeat3Inputs */

const id_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu untuk Menamatkan:`)
};

const ms_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa untuk Menamatkan:`)
};

const da_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid at gennemføre:`)
};

const de_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielzeit:`)
};

const en_us2_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time to Beat:`)
};

const es_es2_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo para completar:`)
};

const es_mx2_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo para completar:`)
};

const fil_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oras para Matapos:`)
};

const fr_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de vie :`)
};

const it_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo per completare:`)
};

const hu_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítési idő:`)
};

const nl_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speelduur:`)
};

const no_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spilletid:`)
};

const pl_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas ukończenia:`)
};

const pt_br2_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para zerar:`)
};

const pt_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para completar:`)
};

const ro_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timp de finalizare:`)
};

const fi_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läpäisyaika:`)
};

const sv_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tid att slå:`)
};

const vi_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian hoàn thành:`)
};

const tr_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitirme Süresi:`)
};

const cs_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doba dohrání:`)
};

const bg_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Време за завършване:`)
};

const ru_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время прохождения:`)
};

const uk_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час проходження:`)
};

const ar_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت الإكمال:`)
};

const hi_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा करने का समय:`)
};

const th_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาในการเล่นจบ:`)
};

const ja_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア時間：`)
};

const zh_cn2_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通关时间:`)
};

const zh_hant1_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通關時間：`)
};

const ko_home_offerhover_timetobeat3 = /** @type {(inputs: Home_Offerhover_Timetobeat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클리어 시간:`)
};

/**
* | output |
* | --- |
* | "Time to Beat:" |
*
* @param {Home_Offerhover_Timetobeat3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_timetobeat3 = /** @type {((inputs?: Home_Offerhover_Timetobeat3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Timetobeat3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_timetobeat3(inputs)
	if (locale === "ms") return ms_home_offerhover_timetobeat3(inputs)
	if (locale === "da") return da_home_offerhover_timetobeat3(inputs)
	if (locale === "de") return de_home_offerhover_timetobeat3(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_timetobeat3(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_timetobeat3(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_timetobeat3(inputs)
	if (locale === "fil") return fil_home_offerhover_timetobeat3(inputs)
	if (locale === "fr") return fr_home_offerhover_timetobeat3(inputs)
	if (locale === "it") return it_home_offerhover_timetobeat3(inputs)
	if (locale === "hu") return hu_home_offerhover_timetobeat3(inputs)
	if (locale === "nl") return nl_home_offerhover_timetobeat3(inputs)
	if (locale === "no") return no_home_offerhover_timetobeat3(inputs)
	if (locale === "pl") return pl_home_offerhover_timetobeat3(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_timetobeat3(inputs)
	if (locale === "pt") return pt_home_offerhover_timetobeat3(inputs)
	if (locale === "ro") return ro_home_offerhover_timetobeat3(inputs)
	if (locale === "fi") return fi_home_offerhover_timetobeat3(inputs)
	if (locale === "sv") return sv_home_offerhover_timetobeat3(inputs)
	if (locale === "vi") return vi_home_offerhover_timetobeat3(inputs)
	if (locale === "tr") return tr_home_offerhover_timetobeat3(inputs)
	if (locale === "cs") return cs_home_offerhover_timetobeat3(inputs)
	if (locale === "bg") return bg_home_offerhover_timetobeat3(inputs)
	if (locale === "ru") return ru_home_offerhover_timetobeat3(inputs)
	if (locale === "uk") return uk_home_offerhover_timetobeat3(inputs)
	if (locale === "ar") return ar_home_offerhover_timetobeat3(inputs)
	if (locale === "hi") return hi_home_offerhover_timetobeat3(inputs)
	if (locale === "th") return th_home_offerhover_timetobeat3(inputs)
	if (locale === "ja") return ja_home_offerhover_timetobeat3(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_timetobeat3(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_timetobeat3(inputs)
	return ko_home_offerhover_timetobeat3(inputs)
});
export { home_offerhover_timetobeat3 as "home.offerHover.timeToBeat" }